import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';

type Props = {
  label: string;
  hint: string;
  children: ReactNode;
};

export function FieldTip({ label, hint, children }: Props) {
  return (
    <div>
      <div className="mb-1 flex items-center gap-1.5">
        <label className="text-xs font-semibold uppercase tracking-wide text-ha-muted">{label}</label>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <button
              type="button"
              className="inline-flex shrink-0 cursor-help rounded-full text-ha-muted outline-none transition hover:text-ha-subtle focus-visible:ring-2 focus-visible:ring-accent/40"
              aria-label={`Ajuda: ${label}`}
            >
              <HelpCircle className="h-[15px] w-[15px]" strokeWidth={1.65} aria-hidden />
            </button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              className="z-50 max-w-xs border border-ha-border bg-ha-card2 px-3 py-2 text-xs leading-snug text-ha-subtle shadow-none"
              sideOffset={4}
            >
              {hint}
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </div>
      {children}
    </div>
  );
}
